module.exports = __webpack_public_path__ + "img/platinum-card-with-logo.be4f7874.png";